module.exports = __webpack_public_path__ + "static/media/triangle-down.058b8503.svg";